import { useGetAnagrafiche } from '@framework/api-client/api/inquiries/anagrafiche/anagrafiche.ts';

/**
 * Valori di anagrafiche da utilizzare per la compilazione.
 */
export function useFillableRegisters() {
  const { data, error, isLoading, isFetching } = useGetAnagrafiche(
    {
      limite: 9000,
    },
    {
      query: {
        keepPreviousData: true,
        staleTime: 30 * 60 * 1000, // 30min
        cacheTime: 30 * 60 * 1000, // 30min
        onError: err => {
          console.error(
            `[useFillableRegisters] Non è stato possibile caricare le variabili di anagrafica.`,
            err,
          );
        },
      },
    },
  );

  // Se fossero necessarie trasformazioni, assicurarsi di farle qui
  // con useMemo o simili
  const registers = data?.dati;

  return {
    registers,
    error,
    isLoading,
    isFetching,
  };
}
